import { bytesToKB, bytesToMB, bytesToGB } from "utils/format"

const convert = (value, unit) => {
  if (value == null) return 0;

  switch (unit) {
    case "KB":
      return bytesToKB(value);
    case "MB":
      return bytesToMB(value);
    case "GB":
      return bytesToGB(value);
    default:
      return Number(value.toFixed(2));
  }
};

export function getLineChartData(nameMap, statsObj, unit = null) {
  const types = ["green", "blue"];

  return Object.keys(nameMap)
    .filter(key => key in statsObj)
    .map((key, index) => ({
      name: nameMap[key],
      type: types[index] || "green",
      data: statsObj[key].map(item => {
        const { timestamp, ...rest } = item;
        const value = Object.values(rest)[0];
        return [
          new Date(timestamp * 1000).toISOString(),
          convert(value, unit),
        ];
      }),
    }));
}

export function getPieChartData(data = [], nameKey, valueKey, unit = null) {
  const typeList = ["primary", "buleLight", "greenPrimary", "yellowLight", "greenLight", "sliver"];

  if (!data?.length) {
    return [{
      name: "",
      value: 0,
      type: typeList[0],
    }]
  }

  return data.map((item, index) => {
    const { [nameKey]: transformName, [valueKey]: transformValue, ...rest } = item;

    return {
      ...rest,
      name: transformName,
      value: convert(transformValue, unit),
      type: typeList[index] ?? "sliver",
    };
  });
}

export function getBarChartData(data, valueConfigs) {
  const time = [];

  const series = valueConfigs.map((item) => ({
    name: item.name,
    key: item.key,
    type: item.type,
    isNegative: !!item.isNegative,
    data: [],
  }));

  for (let i = 0; i < data.length; i++) {
    const item = data[i];

    time.push(new Date(item.timestamp * 1000).toISOString());

    series.forEach((s) => {
      const rawValue = item[s.key] ?? 0;
      const value = s.isNegative ? -Math.abs(rawValue) : rawValue;
      s.data.push(value);
    });
  }

  return { time, series };
}



